import { ChangeEvent, useCallback, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FiltersToolbarSearch } from '@hqo/filters-toolbar';
import { SearchInput } from '@hqo/ui-atoms';
import { useIntl } from 'react-intl';

import { setSearchFilter } from 'store/visits/actions';
import { getSearchFilter } from 'store/visits/selectors';

export const FiltersToolbarSearchInput = (): JSX.Element => {
  const dispatch = useDispatch();
  const reduxSearchValue = useSelector(getSearchFilter);
  const [localSearchValue, setLocalSearchValue] = useState(reduxSearchValue);
  const { formatMessage } = useIntl();
  const searchPlaceholder = formatMessage({
    id: 'labels.filtersToolbar.searchPlaceholder',
    defaultMessage: 'Search...',
  });

  // Debounce: Update Redux after 300ms of no typing
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      dispatch(setSearchFilter(localSearchValue));
    }, 300);

    return () => clearTimeout(timeoutId);
  }, [localSearchValue, dispatch]);

  // Sync local state when Redux state changes externally (e.g., clear filters)
  useEffect(() => {
    setLocalSearchValue(reduxSearchValue);
  }, [reduxSearchValue]);

  const handleSearchChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    setLocalSearchValue(event.target.value);
  }, []);

  return (
    <FiltersToolbarSearch className="relative flex-shrink-0">
      <SearchInput
        className="h-8 w-60 sm:w-88 rounded-lg text-sm placeholder:text-sm font-normal  placeholder:text-muted-foreground"
        value={localSearchValue}
        onChange={handleSearchChange}
        placeholder={searchPlaceholder}
        data-testid="search-input"
        autoComplete="off"
      />
    </FiltersToolbarSearch>
  );
};
